import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DynamicTagModule } from '../dynamictag/dynamictag.module';
import { ZoomModule } from '../../zoom/zoom.module';
import { HttpClientModule } from '@angular/common/http';
import { DynamictagGroupComponent } from './dynamic-tag-group.component';
import { PipeModule } from '../../pipes';
import { SelectModule } from '../../select';
import { DateModule } from '../../date';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    DynamicTagModule
  ],
  declarations: [DynamictagGroupComponent],
  exports: [DynamictagGroupComponent]
})
export class DynamicTagGroupModule { }
